import { render } from "./VatTuBienBanTable.vue?vue&type=template&id=548a9b33&ts=true"
import script from "./VatTuBienBanTable.vue?vue&type=script&lang=ts"
export * from "./VatTuBienBanTable.vue?vue&type=script&lang=ts"

import "./VatTuBienBanTable.vue?vue&type=style&index=0&id=548a9b33&lang=scss"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__